// @mui
import { alpha, useTheme } from '@mui/material/styles';
import { Tooltip, Box } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
//
import IconButtonAnimate from '../../animate/IconButtonAnimate';
import SvgColor from '../../svg-color';
//
import BadgeDot from './BadgeDot';
// RITA-1522
import { HEATMAP_LEISTE_HOEHE } from '../../../features/usage-tracking/heatmap/leistenHoehe';

// ----------------------------------------------------------------------

type Props = {
  open: boolean;
  notDefault: boolean;
  onToggle: VoidFunction;
};

export default function ToggleButton({ notDefault, open, onToggle }: Props) {
  const theme = useTheme();

  return (
    <Box
      // RITA-1522: Das Zahnrad ist der einzige Weg in den Drawer — und damit zum Schalter, der
      // die Heatmap wieder abstellt. Die Leiste des Overlays liegt fix unten auf appBar+1 (1101)
      // und deckte es vollständig zu. Es hebt sich deshalb um die veröffentlichte Leistenhöhe an;
      // ohne Leiste ist die Variable nicht gesetzt und der Ersatzwert 0px lässt es bei 24 px.
      // Bewusst als Inline-Stil: `sx` ist in jsdom nicht lesbar, und dieser Abstand hat einen Test.
      style={{ bottom: `calc(24px + var(${HEATMAP_LEISTE_HOEHE}, 0px))` }}
      sx={{
        p: 0.5,
        right: 24,
        zIndex: 999,
        position: 'fixed',
        borderRadius: '50%',
        boxShadow: `-12px 12px 32px -4px ${alpha(
          theme.palette.mode === 'light' ? theme.palette.grey[600] : theme.palette.common.black,
          0.36,
        )}`,
        ...bgBlur({ color: theme.palette.background.default }),
      }}
    >
      {notDefault && !open && (
        <BadgeDot
          sx={{
            top: 8,
            right: 10,
          }}
        />
      )}

      <Tooltip title="Einstellungen">
        <IconButtonAnimate color="primary" onClick={onToggle} sx={{ p: 1.25 }} data-usage="kopf.einstellungen">
          <SvgColor src="/assets/icons/setting/ic_setting.svg" />
        </IconButtonAnimate>
      </Tooltip>
    </Box>
  );
}
